import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import requests from "../../axios/requests";
import Error404 from "../../components/reuseComponents/Error404";
import { CourseLanding } from "./CourseLanding/CourseLanding";

// Предпросмотр лендинга курса для учителя: тот же CourseLanding, что у ученика
// (front_web), но кнопки покупки/вопроса не выполняют действий.
const landingApi = {
  getSkillsMarket: (ids) => requests.quests.get_skills_market(ids),
  getReviews: (ses) => requests.quests.get_quest_reviews_public(ses),
};

const LandingNew = (props) => {
  const history = useNavigate();
  const [loaded, setLoaded] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (props?.inCourseLanding) return;
    const quest_id = window.location.href.split("/course-preview")[1];
    requests.quests
      .get_quest_new_landing(quest_id)
      .then((res) => setLoaded(res.data))
      .catch((err) => {
        console.error(err?.message, "err");
        if (String(err?.message).includes("404")) setNotFound(true);
      });
  }, [props?.inCourseLanding]);

  // На шаге 3 редактора курса данные - несохранённый черновик формы
  const data = useMemo(() => {
    if (!props?.inCourseLanding) return loaded;
    return {
      ...props.data,
      quest_speakers: props.originalSpeakerProps || props.data?.quest_speakers || [],
      quest_recommendations: props.originalSuitsProps || props.data?.quest_recommendations || [],
      quest_skills: props.originalLearnProps || props.data?.quest_skills || [],
    };
  }, [props, loaded]);

  if (notFound) return <Error404 />;
  if (!data) return <Spin />;

  return (
    <CourseLanding
      data={data}
      api={landingApi}
      isPreview
      onBack={props?.inCourseLanding ? undefined : () => history(-1)}
    />
  );
};

export default LandingNew;
